module.exports = __webpack_public_path__ + "static/16-d67d7a51837372fc883084d61c19aff6.jpg";